import { type ChangeEvent, type FormEvent } from 'react'
import debounce from 'lodash/debounce'
import { snapshot } from 'valtio'
import { addToArray } from '../../../../../shared/utils/arrayUtils'
import { proxyNewUser } from '../../../../../shared/proxies/newUserProxy'
import { executeDetermineUserLists } from '../../../../../shared/apiUtils/executeDetermineUserLists'
import { executeDetermineIsEmailAvailable } from '../../../../../shared/apiUtils/executeDetermineIsEmailAvailable'
import { executeAddNewUser } from './executeAddNewUser'
import { FormFieldNamesEnum } from './formFieldNamesEnum'
import { validators } from './validators'

const handleFetch = async (): Promise<void> => {
  await executeDetermineUserLists({ appendRecords: false, displayLoader: true })
  setTimeout(() => {
    proxyNewUser.completed = false
  }, 3000)
}
export const debouncedHandleFetch = debounce(handleFetch, 100)

export const handleChange = (fieldName: FormFieldNamesEnum) => (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
  // @ts-expect-error
  const val: string = e.target.type === 'checkbox' ? e.target.checked : e.target.value
  processChange(val, fieldName)
}

export const onCheckboxChange = (value: boolean): void => {
  processChange(value, FormFieldNamesEnum.IsAdmin)
}

export const processChange = (val: string | boolean, fieldName: FormFieldNamesEnum): void => {
  proxyNewUser.formValues[fieldName] = val
  proxyNewUser.formDirtied = addToArray(proxyNewUser.formDirtied, fieldName)
  const validator = validators[fieldName]
  if (typeof val === 'string' && validator) {
    proxyNewUser.formErrors[fieldName] = validator(val)
  }
}

export const handleEmailBlur = (fieldName: FormFieldNamesEnum) => async (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
  await executeDetermineIsEmailAvailable({ email: e.target.value })

  if (!proxyNewUser.emailValidationCall.error) {
    proxyNewUser.formBlurred = addToArray(proxyNewUser.formBlurred, fieldName)
  }
}

export const handleBlur = (fieldName: FormFieldNamesEnum) => () => {
  proxyNewUser.formBlurred = addToArray(proxyNewUser.formBlurred, fieldName)
}

export const handleFormSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
  e.preventDefault()
  const { formValues: { email, firstName, lastName, isAdmin } } = snapshot(proxyNewUser)

  if (!email || !firstName || !lastName) { return }

  await executeAddNewUser({
    email: email as string,
    firstName: firstName as string,
    isAdmin: isAdmin as boolean ?? false,
    lastName: lastName as string
  })
  void debouncedHandleFetch()
}
